/**
 * @generated SignedSource<<594031ac0cfd31cce89111b0ae187529>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BillingStatus = "billed" | "unbilled" | "%future added value";
export type Currency = "BRL" | "USD" | "%future added value";
export type DaySheetlyPageCreateMutation$variables = {
  billingStatus?: BillingStatus | null | undefined;
  currency?: Currency | null | undefined;
  date: string;
  description?: string | null | undefined;
  duration: string;
  endDate?: string | null | undefined;
  hourlyRate?: number | null | undefined;
  memberIds?: ReadonlyArray<string> | null | undefined;
  projectId: string;
  title: string;
};
export type DaySheetlyPageCreateMutation$data = {
  readonly createTask: {
    readonly billingStatus: BillingStatus;
    readonly currency: Currency;
    readonly date: string;
    readonly description: string | null | undefined;
    readonly durationMinutes: number;
    readonly endDate: string | null | undefined;
    readonly hourlyRate: number;
    readonly id: string;
    readonly members: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly project: {
      readonly color: string | null | undefined;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly title: string;
  };
};
export type DaySheetlyPageCreateMutation = {
  response: DaySheetlyPageCreateMutation$data;
  variables: DaySheetlyPageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billingStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currency"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "duration"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hourlyRate"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberIds"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "billingStatus",
        "variableName": "billingStatus"
      },
      {
        "kind": "Variable",
        "name": "currency",
        "variableName": "currency"
      },
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "date"
      },
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "duration",
        "variableName": "duration"
      },
      {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "hourlyRate",
        "variableName": "hourlyRate"
      },
      {
        "kind": "Variable",
        "name": "memberIds",
        "variableName": "memberIds"
      },
      {
        "kind": "Variable",
        "name": "projectId",
        "variableName": "projectId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "createTask",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationMinutes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hourlyRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DaySheetlyPageCreateMutation",
    "selections": (v12/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "DaySheetlyPageCreateMutation",
    "selections": (v12/*: any*/)
  },
  "params": {
    "cacheID": "4ebd3f8c5e72221a7fcd3daa58ce02fb",
    "id": null,
    "metadata": {},
    "name": "DaySheetlyPageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation DaySheetlyPageCreateMutation(\n  $title: String!\n  $description: String\n  $date: String!\n  $duration: String!\n  $projectId: ID!\n  $hourlyRate: Float\n  $currency: Currency\n  $billingStatus: BillingStatus\n  $endDate: String\n  $memberIds: [ID!]\n) {\n  createTask(title: $title, description: $description, date: $date, duration: $duration, projectId: $projectId, hourlyRate: $hourlyRate, currency: $currency, billingStatus: $billingStatus, endDate: $endDate, memberIds: $memberIds) {\n    id\n    title\n    description\n    date\n    endDate\n    durationMinutes\n    hourlyRate\n    currency\n    billingStatus\n    project {\n      id\n      name\n      color\n    }\n    members {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5bd29e8e9fcb0f14c6cf8e57bf3cf651";

export default node;
